import { Component, Input } from '@angular/core';
import { SelectedSeat } from 'src/app/2dmap/types';

@Component({
  selector: 'selected-seat-item',
  standalone: true,
  templateUrl: './selected-seat-item.component.html',
  styleUrls: ['./selected-seat-item.component.css'],
})
export class SelectedSeatItemComponent {
  @Input() seat!: SelectedSeat;
}
